/**
 * @param {HTMLInputElement | HTMLTextAreaElement} element
 */
export function performPatternValidation(element) {
  element.setCustomValidity("");
  if (element.checkValidity()) {
    const pattern = new RegExp(element.getAttribute("patternNachricht"));
    if (element.value.match(pattern)[0] !== element.value) {
      element.setCustomValidity(element.getAttribute("title"));
    }
  }
}

/**
 * @param {HTMLInputElement | HTMLTextAreaElement} field
 * @param {string} message
 */
export function setOneTimeValidationMessage(field, message) {
  field.setCustomValidity(message);
  field.reportValidity();
  const handleChange = () => {
    field.setCustomValidity("");
    field.removeEventListener("change", handleChange);
  };
  field.addEventListener("change", handleChange);
}
